// These controls belong to the entire operation, not to an individual truck.
// Explicit false values must take precedence over legacy truck/egress flags.
export function getOperationSiel(operation) {
  if (typeof operation?.siel === "boolean") return operation.siel;
  return (operation?.camiones || []).some((truck) => !!truck.finanzas);
}

export function getOperationFacturacion(operation) {
  if (typeof operation?.facturacion === "boolean") return operation.facturacion;
  return !!operation?.egreso?.[0]?.estadoEgresoFacturacion;
}

export function withOperationControl(operation, field, value) {
  if (!operation || !["siel", "facturacion"].includes(field)) return operation;
  return { ...operation, [field]: !!value };
}
